import aes from "./AES-ECB";
import router from '../router';
export default {
  // 获取用户的基本信息
  getUserInfo(data) {
    let strs = null;
    let userData = localStorage.getItem("data");
    //本地存储的用户信息丢失则调往登录
    if (userData == null || userData == "") {
      // router.push({
      //   path: "/login"
      // })
      // window.location.href = window.location.origin + '/#/login'
      return null;
    } else {
      //解密
      strs = aes.decrypt(userData);
      //本地解密为空时
      if (strs == null || strs == "") {
        // router.push({
        //   path: "/login"
        // })
        return null;
        // window.location.href = window.location.origin + '/#/login'
      }
      strs = JSON.parse(strs);
      // console.log(strs);
      return strs;
    }

  },

};



// WEBPACK FOOTER //
// ./src/utils/getBeaseInfo.js